import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import Layout from '../components/Layout';
// import { AddEditProduct } from '../dashboard/AddEditProduct';
// import { BrandPage } from '../dashboard/BrandPage';
// import { CategoryPage } from '../dashboard/CategoryPage';
import { DashboardPage } from '../dashboard/DashboardPage';
import { InvoicesPage } from '../dashboard/InvoicesPage';
import { ManageAccountsPage } from '../dashboard/ManageAccountsPage';
import { InvoiceDetailPage } from '../dashboard/InvoiceDetailPage';
import { SearchProductPage } from '../dashboard/SearchProductPage';
// import { ProductPage } from '../dashboard/ProductPage';
// import SalesPage from '../dashboard/SalesPage';
// import UsersPage from '../dashboard/UsersPage';

export const DashboardRouter = () => {
    return (
        <div>
            <div>
            <Layout>

                <Switch>
                    <Route
                        exact path="/dashboard/home" 
                        component={ DashboardPage }
                    />
                    <Route
                        exact path="/dashboard/Invoices" 
                        component={ InvoicesPage }
                    />
                    <Route
                        exact path="/dashboard/InvoiceDetail/:invoice_prefix/:invoice_number" 
                        component={ InvoiceDetailPage }
                    />
                    <Route
                        exact path="/dashboard/searchProduct" 
                        component={ SearchProductPage }
                    />
                  
                   
                     <Route
                        exact path="/dashboard/accounts" 
                        component={ ManageAccountsPage }
                    />
                    <Redirect to="/dashboard/home"/>

                </Switch>
                </Layout>

            </div>
        </div>
    )
};
